module.exports = __webpack_public_path__ + "static/media/design.196d66c6.jpg";